export const ConsumerPostSubmissionApprovedStepStyles = {
  stepContainer: 'mb-6',
  stepText: 'font-semibold text-16px',
  stepDetails: 'text-black mt-3',
}
